import { defineStore } from "pinia";
import { ref } from "vue";

export type FeedbackIntent = "issue" | "idea";

export type FeedbackOpenRequest = {
  intent: FeedbackIntent;
  /** Pre-filled message, e.g. "Integration request: ". */
  draft?: string;
  /** Bumped per request so the widget's watcher fires even when the same intent is asked for twice. */
  seq: number;
};

/**
 * Lets any surface open the top nav's FeedbackWidget on a chosen flow. The widget owns its own state;
 * this is only the doorbell.
 */
export const useFeedbackWidgetStore = defineStore("feedbackWidget", () => {
  const openRequest = ref<FeedbackOpenRequest | null>(null);

  const open = (intent: FeedbackIntent, draft?: string) => {
    openRequest.value = { intent, draft, seq: (openRequest.value?.seq ?? 0) + 1 };
  };

  return {
    // state
    openRequest,

    // actions
    open,
  };
});
